"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomersFamiliesWithMembersRequestDto = exports.CustomerFamilyWithMembersDto = exports.CustomerFamilyMemberDto = void 0;
class CustomerFamilyMemberDto {
}
exports.CustomerFamilyMemberDto = CustomerFamilyMemberDto;
class CustomerFamilyWithMembersDto {
}
exports.CustomerFamilyWithMembersDto = CustomerFamilyWithMembersDto;
class CustomersFamiliesWithMembersRequestDto {
}
exports.CustomersFamiliesWithMembersRequestDto = CustomersFamiliesWithMembersRequestDto;
//# sourceMappingURL=family-customer.dto.js.map